"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = recipientSaga;
var _effects = require("redux-saga/effects");
var _recipient = require("./recipient.action");
var _recipient2 = require("./recipient.constant");
var _services = require("../../../../services");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(recipientSaga);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @flow
/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
function recipientList(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _payload, _payload$responseStat, _payload2, _payload2$responseSta, _payload3, _payload4, _payload5, _payload5$colLockedUn, _payload6, _payload6$colLockedUn, _payload7, _payload7$colIsActive, _payload8, _payload8$colIsActive, _payload9, _payload9$colIsActive, _payload10, _payload10$yearList, _payload11, _payload11$yearList, _payload12, _payload12$fkSurveyId, _payload13, _payload13$fkSurveyId, _payload14, _payload15, _payload16, _payload16$tags, _payload18, _payload19, _response$data, filter, _payload17, _payload17$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          filter = {}; // Status List
          if ((_payload = payload) !== null && _payload !== void 0 && (_payload$responseStat = _payload.responseStatusIdList) !== null && _payload$responseStat !== void 0 && _payload$responseStat.value) filter["responseStatusIdList"] = (_payload2 = payload) === null || _payload2 === void 0 ? void 0 : (_payload2$responseSta = _payload2.responseStatusIdList) === null || _payload2$responseSta === void 0 ? void 0 : _payload2$responseSta.value;else if (Array.isArray((_payload3 = payload) === null || _payload3 === void 0 ? void 0 : _payload3.responseStatusIdList)) filter["responseStatusIdList"] = (_payload4 = payload) === null || _payload4 === void 0 ? void 0 : _payload4.responseStatusIdList;

          // Locked Unlocked
          if (((_payload5 = payload) === null || _payload5 === void 0 ? void 0 : (_payload5$colLockedUn = _payload5.colLockedUnlocked) === null || _payload5$colLockedUn === void 0 ? void 0 : _payload5$colLockedUn.length) === 2) {
            delete payload.colLockedUnlocked;
          } else if (((_payload6 = payload) === null || _payload6 === void 0 ? void 0 : (_payload6$colLockedUn = _payload6.colLockedUnlocked) === null || _payload6$colLockedUn === void 0 ? void 0 : _payload6$colLockedUn.length) === 1) {
            payload.colLockedUnlocked[0] === "locked" && (filter["locked"] = true);
            payload.colLockedUnlocked[0] === "unLocked" && (filter["unlocked"] = true);
          }

          //Live Paused Locked
          if (((_payload7 = payload) === null || _payload7 === void 0 ? void 0 : (_payload7$colIsActive = _payload7.colIsActive) === null || _payload7$colIsActive === void 0 ? void 0 : _payload7$colIsActive.length) === 3 && payload.colIsActive.includes("live") && payload.colIsActive.includes("paused") && payload.colIsActive.includes("locked")) {
            delete payload.colIsActive;
          } else if (((_payload8 = payload) === null || _payload8 === void 0 ? void 0 : (_payload8$colIsActive = _payload8.colIsActive) === null || _payload8$colIsActive === void 0 ? void 0 : _payload8$colIsActive.length) === 2) {
            payload.colIsActive.includes("live") && (filter["live"] = true);
            payload.colIsActive.includes("paused") && (filter["paused"] = true);
            payload.colIsActive.includes("locked") && (filter["locked"] = true);
          } else if (((_payload9 = payload) === null || _payload9 === void 0 ? void 0 : (_payload9$colIsActive = _payload9.colIsActive) === null || _payload9$colIsActive === void 0 ? void 0 : _payload9$colIsActive.length) === 1) {
            payload.colIsActive[0] === "live" && (filter["live"] = true);
            payload.colIsActive[0] === "paused" && (filter["paused"] = true);
            payload.colIsActive[0] === "locked" && (filter["locked"] = true);
          }

          // Year
          if ((_payload10 = payload) !== null && _payload10 !== void 0 && (_payload10$yearList = _payload10.yearList) !== null && _payload10$yearList !== void 0 && _payload10$yearList.value) filter["colFiscalYear"] = (_payload11 = payload) === null || _payload11 === void 0 ? void 0 : (_payload11$yearList = _payload11.yearList) === null || _payload11$yearList === void 0 ? void 0 : _payload11$yearList.value;

          // Survey Name
          if ((_payload12 = payload) !== null && _payload12 !== void 0 && (_payload12$fkSurveyId = _payload12.fkSurveyIdList) !== null && _payload12$fkSurveyId !== void 0 && _payload12$fkSurveyId.value) filter["fkSurveyIdList"] = (_payload13 = payload) === null || _payload13 === void 0 ? void 0 : (_payload13$fkSurveyId = _payload13.fkSurveyIdList) === null || _payload13$fkSurveyId === void 0 ? void 0 : _payload13$fkSurveyId.value;else if (Array.isArray((_payload14 = payload) === null || _payload14 === void 0 ? void 0 : _payload14.fkSurveyIdList)) filter["fkSurveyIdList"] = (_payload15 = payload) === null || _payload15 === void 0 ? void 0 : _payload15.fkSurveyIdList;

          // Tag
          if (((_payload16 = payload) === null || _payload16 === void 0 ? void 0 : (_payload16$tags = _payload16.tags) === null || _payload16$tags === void 0 ? void 0 : _payload16$tags.length) > 0) {
            colTags = "";
            (_payload17 = payload) === null || _payload17 === void 0 ? void 0 : (_payload17$tags = _payload17.tags) === null || _payload17$tags === void 0 ? void 0 : _payload17$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload18 = payload) === null || _payload18 === void 0 ? true : delete _payload18.responseStatusIdList;
          (_payload19 = payload) === null || _payload19 === void 0 ? true : delete _payload19.colLockedUnlocked;
          delete payload.colIsActive;
          delete payload.yearList;
          delete payload.fkSurveyIdList;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context.next = 18;
          return (0, _effects.call)(_services.recipientListApi, payload);
        case 18:
          response = _context.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 200)) {
            _context.next = 24;
            break;
          }
          _context.next = 22;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LIST, response === null || response === void 0 ? void 0 : response.data));
        case 22:
          _context.next = 26;
          break;
        case 24:
          _context.next = 26;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST, response === null || response === void 0 ? void 0 : response.data));
        case 26:
          _context.next = 32;
          break;
        case 28:
          _context.prev = 28;
          _context.t0 = _context["catch"](0);
          _context.next = 32;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST, _context.t0));
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 28]]);
  })();
}

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
function recipientListLink(_ref2) {
  var payload = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _payload20, _payload20$responseSt, _payload21, _payload21$responseSt, _payload22, _payload23, _payload24, _payload24$colLockedU, _payload25, _payload25$colLockedU, _payload26, _payload26$tags, _payload28, _payload29, _response$data2, filter, _payload27, _payload27$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          filter = {}; // Status List
          if ((_payload20 = payload) !== null && _payload20 !== void 0 && (_payload20$responseSt = _payload20.responseStatusIdList) !== null && _payload20$responseSt !== void 0 && _payload20$responseSt.value) filter["responseStatusIdList"] = (_payload21 = payload) === null || _payload21 === void 0 ? void 0 : (_payload21$responseSt = _payload21.responseStatusIdList) === null || _payload21$responseSt === void 0 ? void 0 : _payload21$responseSt.value;else if (Array.isArray((_payload22 = payload) === null || _payload22 === void 0 ? void 0 : _payload22.responseStatusIdList)) filter["responseStatusIdList"] = (_payload23 = payload) === null || _payload23 === void 0 ? void 0 : _payload23.responseStatusIdList;

          // Locked Unlocked
          if (((_payload24 = payload) === null || _payload24 === void 0 ? void 0 : (_payload24$colLockedU = _payload24.colLockedUnlocked) === null || _payload24$colLockedU === void 0 ? void 0 : _payload24$colLockedU.length) === 2) {
            delete payload.colLockedUnlocked;
          } else if (((_payload25 = payload) === null || _payload25 === void 0 ? void 0 : (_payload25$colLockedU = _payload25.colLockedUnlocked) === null || _payload25$colLockedU === void 0 ? void 0 : _payload25$colLockedU.length) === 1) {
            payload.colLockedUnlocked[0] === "locked" && (filter["locked"] = true);
            payload.colLockedUnlocked[0] === "unLocked" && (filter["unlocked"] = true);
          }

          // Tag
          if (((_payload26 = payload) === null || _payload26 === void 0 ? void 0 : (_payload26$tags = _payload26.tags) === null || _payload26$tags === void 0 ? void 0 : _payload26$tags.length) > 0) {
            colTags = "";
            (_payload27 = payload) === null || _payload27 === void 0 ? void 0 : (_payload27$tags = _payload27.tags) === null || _payload27$tags === void 0 ? void 0 : _payload27$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload28 = payload) === null || _payload28 === void 0 ? true : delete _payload28.responseStatusIdList;
          (_payload29 = payload) === null || _payload29 === void 0 ? true : delete _payload29.colLockedUnlocked;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context2.next = 12;
          return (0, _effects.call)(_services.recipientListApi, payload);
        case 12:
          response = _context2.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) === 200)) {
            _context2.next = 18;
            break;
          }
          _context2.next = 16;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LIST_LINK, response === null || response === void 0 ? void 0 : response.data));
        case 16:
          _context2.next = 20;
          break;
        case 18:
          _context2.next = 20;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST_LINK, response === null || response === void 0 ? void 0 : response.data));
        case 20:
          _context2.next = 26;
          break;
        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 26;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST_LINK, _context2.t0));
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 22]]);
  })();
}

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
function recipientListSearch(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _response$data3, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.recipientListApi, payload);
        case 3:
          response = _context3.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === 200)) {
            _context3.next = 9;
            break;
          }
          _context3.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LIST_SEARCH, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context3.next = 11;
          break;
        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST_SEARCH, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context3.next = 17;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST_SEARCH, _context3.t0));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
function recipientCreate(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _response$data4, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.recipientCreateApi, payload);
        case 3:
          response = _context4.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) === 201)) {
            _context4.next = 9;
            break;
          }
          _context4.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.CREATE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context4.next = 11;
          break;
        case 9:
          _context4.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.CREATE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context4.next = 17;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.CREATE, _context4.t0));
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 13]]);
  })();
}

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
function recipientUpdate(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _response$data5, response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.recipientUpdateApi, payload);
        case 3:
          response = _context5.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.code) === 202)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.UPDATE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context5.next = 11;
          break;
        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UPDATE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context5.next = 17;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UPDATE, _context5.t0));
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 13]]);
  })();
}

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund.
 */
function recipientLinkedFund(_ref6) {
  var payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _response$data6, response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.recipientLinkedFundApi, payload);
        case 3:
          response = _context6.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 200)) {
            _context6.next = 9;
            break;
          }
          _context6.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context6.next = 11;
          break;
        case 9:
          _context6.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context6.next = 17;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINKED_FUND, _context6.t0));
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
function recipientSaveLinkedFund(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _response$data7, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.recipientSaveLinkedFundApi, payload);
        case 3:
          response = _context7.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.code) === 201)) {
            _context7.next = 9;
            break;
          }
          _context7.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SAVE_LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context7.next = 11;
          break;
        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SAVE_LINKED_FUND, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context7.next = 17;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SAVE_LINKED_FUND, _context7.t0));
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 13]]);
  })();
}

/**
 * Lock
 * @param payload
 * @returns api response
 * @description this function used to Lock.
 */
function recipientLock(_ref8) {
  var payload = _ref8.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _response$data8, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.recipientLockApi, payload);
        case 3:
          response = _context8.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.code) === 200)) {
            _context8.next = 9;
            break;
          }
          _context8.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context8.next = 11;
          break;
        case 9:
          _context8.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context8.next = 17;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LOCK, _context8.t0));
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 13]]);
  })();
}

/**
 * Lock Bulk
 * @param payload
 *  @returns api response
 * @description this function used to Lock Bulk.
 */
function recipientLockBulk(_ref9) {
  var payload = _ref9.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _payload30, _payload30$responseSt, _payload31, _payload31$responseSt, _payload32, _payload33, _payload34, _payload34$colLockedU, _payload35, _payload35$colLockedU, _payload36, _payload36$tags, _payload38, _payload39, _response$data9, filter, _payload37, _payload37$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          filter = {}; // Status List
          if ((_payload30 = payload) !== null && _payload30 !== void 0 && (_payload30$responseSt = _payload30.responseStatusIdList) !== null && _payload30$responseSt !== void 0 && _payload30$responseSt.value) filter["responseStatusIdList"] = (_payload31 = payload) === null || _payload31 === void 0 ? void 0 : (_payload31$responseSt = _payload31.responseStatusIdList) === null || _payload31$responseSt === void 0 ? void 0 : _payload31$responseSt.value;else if (Array.isArray((_payload32 = payload) === null || _payload32 === void 0 ? void 0 : _payload32.responseStatusIdList)) filter["responseStatusIdList"] = (_payload33 = payload) === null || _payload33 === void 0 ? void 0 : _payload33.responseStatusIdList;

          // Locked Unlocked
          if (((_payload34 = payload) === null || _payload34 === void 0 ? void 0 : (_payload34$colLockedU = _payload34.colLockedUnlocked) === null || _payload34$colLockedU === void 0 ? void 0 : _payload34$colLockedU.length) === 2) {
            delete payload.colLockedUnlocked;
          } else if (((_payload35 = payload) === null || _payload35 === void 0 ? void 0 : (_payload35$colLockedU = _payload35.colLockedUnlocked) === null || _payload35$colLockedU === void 0 ? void 0 : _payload35$colLockedU.length) === 1) {
            payload.colLockedUnlocked[0] === "locked" && (filter["locked"] = true);
            payload.colLockedUnlocked[0] === "unLocked" && (filter["unlocked"] = true);
          }

          // Tag
          if (((_payload36 = payload) === null || _payload36 === void 0 ? void 0 : (_payload36$tags = _payload36.tags) === null || _payload36$tags === void 0 ? void 0 : _payload36$tags.length) > 0) {
            colTags = "";
            (_payload37 = payload) === null || _payload37 === void 0 ? void 0 : (_payload37$tags = _payload37.tags) === null || _payload37$tags === void 0 ? void 0 : _payload37$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload38 = payload) === null || _payload38 === void 0 ? true : delete _payload38.responseStatusIdList;
          (_payload39 = payload) === null || _payload39 === void 0 ? true : delete _payload39.colLockedUnlocked;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context9.next = 12;
          return (0, _effects.call)(_services.recipientLockBulkApi, payload);
        case 12:
          response = _context9.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.code) === 207)) {
            _context9.next = 18;
            break;
          }
          _context9.next = 16;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 16:
          _context9.next = 20;
          break;
        case 18:
          _context9.next = 20;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 20:
          _context9.next = 26;
          break;
        case 22:
          _context9.prev = 22;
          _context9.t0 = _context9["catch"](0);
          _context9.next = 26;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LOCK_BULK, _context9.t0));
        case 26:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 22]]);
  })();
}

/**
 * Unlock
 * @param payload
 * @returns api response
 * @description this function used to Unlock.
 */
function recipientUnlock(_ref10) {
  var payload = _ref10.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _response$data10, response;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.recipientUnlockApi, payload);
        case 3:
          response = _context10.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.code) === 200)) {
            _context10.next = 9;
            break;
          }
          _context10.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.UNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context10.next = 11;
          break;
        case 9:
          _context10.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNLOCK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context10.next = 17;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](0);
          _context10.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNLOCK, _context10.t0));
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 13]]);
  })();
}

/**
 * Unlock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Unlock Bulk.
 */
function recipientUnlockBulk(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var _payload40, _payload40$responseSt, _payload41, _payload41$responseSt, _payload42, _payload43, _payload44, _payload44$colLockedU, _payload45, _payload45$colLockedU, _payload46, _payload46$tags, _payload48, _payload49, _response$data11, filter, _payload47, _payload47$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          filter = {}; // Status List
          if ((_payload40 = payload) !== null && _payload40 !== void 0 && (_payload40$responseSt = _payload40.responseStatusIdList) !== null && _payload40$responseSt !== void 0 && _payload40$responseSt.value) filter["responseStatusIdList"] = (_payload41 = payload) === null || _payload41 === void 0 ? void 0 : (_payload41$responseSt = _payload41.responseStatusIdList) === null || _payload41$responseSt === void 0 ? void 0 : _payload41$responseSt.value;else if (Array.isArray((_payload42 = payload) === null || _payload42 === void 0 ? void 0 : _payload42.responseStatusIdList)) filter["responseStatusIdList"] = (_payload43 = payload) === null || _payload43 === void 0 ? void 0 : _payload43.responseStatusIdList;

          // Locked Unlocked
          if (((_payload44 = payload) === null || _payload44 === void 0 ? void 0 : (_payload44$colLockedU = _payload44.colLockedUnlocked) === null || _payload44$colLockedU === void 0 ? void 0 : _payload44$colLockedU.length) === 2) {
            delete payload.colLockedUnlocked;
          } else if (((_payload45 = payload) === null || _payload45 === void 0 ? void 0 : (_payload45$colLockedU = _payload45.colLockedUnlocked) === null || _payload45$colLockedU === void 0 ? void 0 : _payload45$colLockedU.length) === 1) {
            payload.colLockedUnlocked[0] === "locked" && (filter["locked"] = true);
            payload.colLockedUnlocked[0] === "unLocked" && (filter["unlocked"] = true);
          }

          // Tag
          if (((_payload46 = payload) === null || _payload46 === void 0 ? void 0 : (_payload46$tags = _payload46.tags) === null || _payload46$tags === void 0 ? void 0 : _payload46$tags.length) > 0) {
            colTags = "";
            (_payload47 = payload) === null || _payload47 === void 0 ? void 0 : (_payload47$tags = _payload47.tags) === null || _payload47$tags === void 0 ? void 0 : _payload47$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload48 = payload) === null || _payload48 === void 0 ? true : delete _payload48.responseStatusIdList;
          (_payload49 = payload) === null || _payload49 === void 0 ? true : delete _payload49.colLockedUnlocked;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context11.next = 12;
          return (0, _effects.call)(_services.recipientUnlockBulkApi, payload);
        case 12:
          response = _context11.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.code) === 207)) {
            _context11.next = 18;
            break;
          }
          _context11.next = 16;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.UNLOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 16:
          _context11.next = 20;
          break;
        case 18:
          _context11.next = 20;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNLOCK_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 20:
          _context11.next = 26;
          break;
        case 22:
          _context11.prev = 22;
          _context11.t0 = _context11["catch"](0);
          _context11.next = 26;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNLOCK_BULK, _context11.t0));
        case 26:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 22]]);
  })();
}

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
function recipientSoftDelete(_ref12) {
  var payload = _ref12.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var _response$data12, response;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.recipientSoftDeleteApi, payload);
        case 3:
          response = _context12.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.code) === 200)) {
            _context12.next = 9;
            break;
          }
          _context12.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context12.next = 11;
          break;
        case 9:
          _context12.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SOFT_DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context12.next = 17;
          break;
        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](0);
          _context12.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SOFT_DELETE, _context12.t0));
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 13]]);
  })();
}

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
function recipientSoftDeleteBulk(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var _response$data13, response;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.recipientSoftDeleteBulkApi, payload);
        case 3:
          response = _context13.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.code) === 202)) {
            _context13.next = 9;
            break;
          }
          _context13.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SOFT_DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context13.next = 11;
          break;
        case 9:
          _context13.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SOFT_DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context13.next = 17;
          break;
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](0);
          _context13.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SOFT_DELETE_BULK, _context13.t0));
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 13]]);
  })();
}

/**
 * Submit
 * @param payload
 * @returns api response
 * @description this function used to Submit.
 */
function recipientSubmit(_ref14) {
  var payload = _ref14.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
    var _response$data14, response;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.recipientSubmitApi, payload);
        case 3:
          response = _context14.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.code) === 202)) {
            _context14.next = 9;
            break;
          }
          _context14.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SUBMIT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context14.next = 11;
          break;
        case 9:
          _context14.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SUBMIT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context14.next = 17;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](0);
          _context14.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SUBMIT, _context14.t0));
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 13]]);
  })();
}

/**
 * Submit Bulk
 * @param payload
 * @returns api response
 * @description this function used to Submit Bulk.
 */
function recipientSubmitBulk(_ref15) {
  var payload = _ref15.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    var _response$data15, response;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.recipientSubmitBulkApi, payload);
        case 3:
          response = _context15.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.code) === 200)) {
            _context15.next = 9;
            break;
          }
          _context15.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SUBMIT_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context15.next = 11;
          break;
        case 9:
          _context15.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SUBMIT_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context15.next = 17;
          break;
        case 13:
          _context15.prev = 13;
          _context15.t0 = _context15["catch"](0);
          _context15.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SUBMIT_BULK, _context15.t0));
        case 17:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 13]]);
  })();
}

/**
 * Approve
 * @param payload
 * @returns api response
 * @description this function used to Approve.
 */
function recipientApprove(_ref16) {
  var payload = _ref16.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
    var _response$data16, response;
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.recipientApproveApi, payload);
        case 3:
          response = _context16.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.code) === 202)) {
            _context16.next = 9;
            break;
          }
          _context16.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.APPROVE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context16.next = 11;
          break;
        case 9:
          _context16.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.APPROVE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context16.next = 17;
          break;
        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16["catch"](0);
          _context16.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.APPROVE, _context16.t0));
        case 17:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 13]]);
  })();
}

/**
 * Approve Bulk
 * @param payload
 * @returns api response
 * @description this function used to Approve Bulk.
 */
function recipientApproveBulk(_ref17) {
  var payload = _ref17.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
    var _response$data17, response;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.recipientApproveBulkApi, payload);
        case 3:
          response = _context17.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.code) === 200)) {
            _context17.next = 9;
            break;
          }
          _context17.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.APPROVE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context17.next = 11;
          break;
        case 9:
          _context17.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.APPROVE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context17.next = 17;
          break;
        case 13:
          _context17.prev = 13;
          _context17.t0 = _context17["catch"](0);
          _context17.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.APPROVE_BULK, _context17.t0));
        case 17:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 13]]);
  })();
}

/**
 * Copy Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
function recipientCopyUrl(_ref18) {
  var payload = _ref18.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
    var _response$data18, response;
    return _regeneratorRuntime().wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.prev = 0;
          _context18.next = 3;
          return (0, _effects.call)(_services.recipientCopyUrlApi, payload);
        case 3:
          response = _context18.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data18 = response.data) === null || _response$data18 === void 0 ? void 0 : _response$data18.code) === 200)) {
            _context18.next = 9;
            break;
          }
          _context18.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.COPY_URL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context18.next = 11;
          break;
        case 9:
          _context18.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.COPY_URL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context18.next = 17;
          break;
        case 13:
          _context18.prev = 13;
          _context18.t0 = _context18["catch"](0);
          _context18.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.COPY_URL, _context18.t0));
        case 17:
        case "end":
          return _context18.stop();
      }
    }, _callee18, null, [[0, 13]]);
  })();
}

/**
 * Download
 * @param payload
 * @returns api response
 * @description this function used to Download.
 */
function recipientDownload(_ref19) {
  var payload = _ref19.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
    var _response$data19, response;
    return _regeneratorRuntime().wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.prev = 0;
          _context19.next = 3;
          return (0, _effects.call)(_services.recipientDownloadApi, payload);
        case 3:
          response = _context19.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data19 = response.data) === null || _response$data19 === void 0 ? void 0 : _response$data19.code) === 200)) {
            _context19.next = 9;
            break;
          }
          _context19.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.DOWNLOAD, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context19.next = 11;
          break;
        case 9:
          _context19.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DOWNLOAD, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context19.next = 17;
          break;
        case 13:
          _context19.prev = 13;
          _context19.t0 = _context19["catch"](0);
          _context19.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DOWNLOAD, _context19.t0));
        case 17:
        case "end":
          return _context19.stop();
      }
    }, _callee19, null, [[0, 13]]);
  })();
}

/**
 * Download All
 * @param payload
 * @returns api response
 * @description this function used to Download All.
 */
function recipientDownloadAll(_ref20) {
  var payload = _ref20.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
    var _response$data20, response;
    return _regeneratorRuntime().wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.prev = 0;
          _context20.next = 3;
          return (0, _effects.call)(_services.recipientDownloadAllApi, payload);
        case 3:
          response = _context20.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data20 = response.data) === null || _response$data20 === void 0 ? void 0 : _response$data20.code) === 200)) {
            _context20.next = 9;
            break;
          }
          _context20.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.DOWNLOAD_ALL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context20.next = 11;
          break;
        case 9:
          _context20.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DOWNLOAD_ALL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context20.next = 17;
          break;
        case 13:
          _context20.prev = 13;
          _context20.t0 = _context20["catch"](0);
          _context20.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DOWNLOAD_ALL, _context20.t0));
        case 17:
        case "end":
          return _context20.stop();
      }
    }, _callee20, null, [[0, 13]]);
  })();
}

/**
 * Download Survey Response
 * @param payload
 * @returns api response
 * @description this function used to Download Survey Response.
 */
function recipientDownloadSurveyResponse(_ref21) {
  var payload = _ref21.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
    var _response$data21, response;
    return _regeneratorRuntime().wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.prev = 0;
          _context21.next = 3;
          return (0, _effects.call)(_services.recipientDownloadSurveyResponseApi, payload);
        case 3:
          response = _context21.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data21 = response.data) === null || _response$data21 === void 0 ? void 0 : _response$data21.code) === 200)) {
            _context21.next = 9;
            break;
          }
          _context21.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context21.next = 11;
          break;
        case 9:
          _context21.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context21.next = 17;
          break;
        case 13:
          _context21.prev = 13;
          _context21.t0 = _context21["catch"](0);
          _context21.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, _context21.t0));
        case 17:
        case "end":
          return _context21.stop();
      }
    }, _callee21, null, [[0, 13]]);
  })();
}

// deleted data

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
function recipientSoftDeleteList(_ref22) {
  var payload = _ref22.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
    var _payload50, _payload50$fkUserIdLi, _payload51, _payload51$fkUserIdLi, _payload52, _payload53, _payload54, _payload54$fkDeletedB, _payload55, _payload55$fkDeletedB, _payload56, _payload57, _payload58, _payload59, _payload60, _payload61, _payload61$yearList, _payload62, _payload62$yearList, _payload63, _payload63$tags, _response$data22, filter, _payload64, _payload64$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.prev = 0;
          filter = {}; // Owner
          if ((_payload50 = payload) !== null && _payload50 !== void 0 && (_payload50$fkUserIdLi = _payload50.fkUserIdList) !== null && _payload50$fkUserIdLi !== void 0 && _payload50$fkUserIdLi.value) filter["fkUserIdList"] = (_payload51 = payload) === null || _payload51 === void 0 ? void 0 : (_payload51$fkUserIdLi = _payload51.fkUserIdList) === null || _payload51$fkUserIdLi === void 0 ? void 0 : _payload51$fkUserIdLi.value;else if (Array.isArray((_payload52 = payload) === null || _payload52 === void 0 ? void 0 : _payload52.fkUserIdList)) filter["fkUserIdList"] = (_payload53 = payload) === null || _payload53 === void 0 ? void 0 : _payload53.fkUserIdList;
          if ((_payload54 = payload) !== null && _payload54 !== void 0 && (_payload54$fkDeletedB = _payload54.fkDeletedByList) !== null && _payload54$fkDeletedB !== void 0 && _payload54$fkDeletedB.value) filter["fkDeletedByList"] = (_payload55 = payload) === null || _payload55 === void 0 ? void 0 : (_payload55$fkDeletedB = _payload55.fkDeletedByList) === null || _payload55$fkDeletedB === void 0 ? void 0 : _payload55$fkDeletedB.value;else if (Array.isArray((_payload56 = payload) === null || _payload56 === void 0 ? void 0 : _payload56.fkDeletedByList)) filter["fkDeletedByList"] = (_payload57 = payload) === null || _payload57 === void 0 ? void 0 : _payload57.fkDeletedByList;
          if (((_payload58 = payload) === null || _payload58 === void 0 ? void 0 : _payload58.dateRange) === "date" && (_payload59 = payload) !== null && _payload59 !== void 0 && _payload59.from && (_payload60 = payload) !== null && _payload60 !== void 0 && _payload60.to) {
            filter["startDate"] = payload.from;
            filter["endDate"] = payload.to;
          }

          // Year
          if ((_payload61 = payload) !== null && _payload61 !== void 0 && (_payload61$yearList = _payload61.yearList) !== null && _payload61$yearList !== void 0 && _payload61$yearList.value) filter["colFiscalYear"] = (_payload62 = payload) === null || _payload62 === void 0 ? void 0 : (_payload62$yearList = _payload62.yearList) === null || _payload62$yearList === void 0 ? void 0 : _payload62$yearList.value;
          if (((_payload63 = payload) === null || _payload63 === void 0 ? void 0 : (_payload63$tags = _payload63.tags) === null || _payload63$tags === void 0 ? void 0 : _payload63$tags.length) > 0) {
            colTags = "";
            (_payload64 = payload) === null || _payload64 === void 0 ? void 0 : (_payload64$tags = _payload64.tags) === null || _payload64$tags === void 0 ? void 0 : _payload64$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          delete payload.fkUserIdList;
          delete payload.yearList;
          delete payload.fkDeletedByList;
          delete payload.colTags;
          delete payload.from;
          delete payload.to;
          delete payload.tags;
          delete payload.dateRange;
          delete payload.startDate;
          delete payload.endDate;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context22.next = 20;
          return (0, _effects.call)(_services.recipientSoftDeleteListApi, payload);
        case 20:
          response = _context22.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data22 = response.data) === null || _response$data22 === void 0 ? void 0 : _response$data22.code) === 200)) {
            _context22.next = 26;
            break;
          }
          _context22.next = 24;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 24:
          _context22.next = 28;
          break;
        case 26:
          _context22.next = 28;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SOFT_DELETE_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 28:
          _context22.next = 34;
          break;
        case 30:
          _context22.prev = 30;
          _context22.t0 = _context22["catch"](0);
          _context22.next = 34;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SOFT_DELETE_LIST, _context22.t0));
        case 34:
        case "end":
          return _context22.stop();
      }
    }, _callee22, null, [[0, 30]]);
  })();
}

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
function recipientRestore(_ref23) {
  var payload = _ref23.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
    var _response$data23, response;
    return _regeneratorRuntime().wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return (0, _effects.call)(_services.recipientRestoreApi, payload);
        case 3:
          response = _context23.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data23 = response.data) === null || _response$data23 === void 0 ? void 0 : _response$data23.code) === 200)) {
            _context23.next = 9;
            break;
          }
          _context23.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.RESTORE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context23.next = 11;
          break;
        case 9:
          _context23.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.RESTORE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context23.next = 17;
          break;
        case 13:
          _context23.prev = 13;
          _context23.t0 = _context23["catch"](0);
          _context23.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.RESTORE, _context23.t0));
        case 17:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 13]]);
  })();
}

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
function recipientRestoreBulk(_ref24) {
  var payload = _ref24.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var _payload65, _payload65$responseSt, _payload66, _payload66$responseSt, _payload67, _payload68, _payload69, _payload69$colLockedU, _payload70, _payload70$colLockedU, _payload71, _payload71$tags, _payload73, _payload74, _response$data24, filter, _payload72, _payload72$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          filter = {}; // Status List
          if ((_payload65 = payload) !== null && _payload65 !== void 0 && (_payload65$responseSt = _payload65.responseStatusIdList) !== null && _payload65$responseSt !== void 0 && _payload65$responseSt.value) filter["responseStatusIdList"] = (_payload66 = payload) === null || _payload66 === void 0 ? void 0 : (_payload66$responseSt = _payload66.responseStatusIdList) === null || _payload66$responseSt === void 0 ? void 0 : _payload66$responseSt.value;else if (Array.isArray((_payload67 = payload) === null || _payload67 === void 0 ? void 0 : _payload67.responseStatusIdList)) filter["responseStatusIdList"] = (_payload68 = payload) === null || _payload68 === void 0 ? void 0 : _payload68.responseStatusIdList;

          // Locked Unlocked
          if (((_payload69 = payload) === null || _payload69 === void 0 ? void 0 : (_payload69$colLockedU = _payload69.colLockedUnlocked) === null || _payload69$colLockedU === void 0 ? void 0 : _payload69$colLockedU.length) === 2) {
            delete payload.colLockedUnlocked;
          } else if (((_payload70 = payload) === null || _payload70 === void 0 ? void 0 : (_payload70$colLockedU = _payload70.colLockedUnlocked) === null || _payload70$colLockedU === void 0 ? void 0 : _payload70$colLockedU.length) === 1) {
            payload.colLockedUnlocked[0] === "locked" && (filter["locked"] = true);
            payload.colLockedUnlocked[0] === "unLocked" && (filter["unlocked"] = true);
          }

          // Tag
          if (((_payload71 = payload) === null || _payload71 === void 0 ? void 0 : (_payload71$tags = _payload71.tags) === null || _payload71$tags === void 0 ? void 0 : _payload71$tags.length) > 0) {
            colTags = "";
            (_payload72 = payload) === null || _payload72 === void 0 ? void 0 : (_payload72$tags = _payload72.tags) === null || _payload72$tags === void 0 ? void 0 : _payload72$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload73 = payload) === null || _payload73 === void 0 ? true : delete _payload73.responseStatusIdList;
          (_payload74 = payload) === null || _payload74 === void 0 ? true : delete _payload74.colLockedUnlocked;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context24.next = 12;
          return (0, _effects.call)(_services.recipientRestoreBulkApi, payload);
        case 12:
          response = _context24.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data24 = response.data) === null || _response$data24 === void 0 ? void 0 : _response$data24.code) === 207)) {
            _context24.next = 18;
            break;
          }
          _context24.next = 16;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.RESTORE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 16:
          _context24.next = 20;
          break;
        case 18:
          _context24.next = 20;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.RESTORE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 20:
          _context24.next = 26;
          break;
        case 22:
          _context24.prev = 22;
          _context24.t0 = _context24["catch"](0);
          _context24.next = 26;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.RESTORE_BULK, _context24.t0));
        case 26:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[0, 22]]);
  })();
}

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to Delete.
 */
function recipientDelete(_ref25) {
  var payload = _ref25.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
    var _response$data25, response;
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.prev = 0;
          _context25.next = 3;
          return (0, _effects.call)(_services.recipientDeleteApi, payload);
        case 3:
          response = _context25.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data25 = response.data) === null || _response$data25 === void 0 ? void 0 : _response$data25.code) === 200)) {
            _context25.next = 9;
            break;
          }
          _context25.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context25.next = 11;
          break;
        case 9:
          _context25.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context25.next = 17;
          break;
        case 13:
          _context25.prev = 13;
          _context25.t0 = _context25["catch"](0);
          _context25.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DELETE, _context25.t0));
        case 17:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[0, 13]]);
  })();
}

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
function recipientDeleteBulk(_ref26) {
  var payload = _ref26.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
    var _payload75, _payload75$responseSt, _payload76, _payload76$responseSt, _payload77, _payload78, _payload79, _payload79$colLockedU, _payload80, _payload80$colLockedU, _payload81, _payload81$tags, _payload83, _payload84, _response$data26, filter, _payload82, _payload82$tags, colTags, response;
    return _regeneratorRuntime().wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          filter = {}; // Status List
          if ((_payload75 = payload) !== null && _payload75 !== void 0 && (_payload75$responseSt = _payload75.responseStatusIdList) !== null && _payload75$responseSt !== void 0 && _payload75$responseSt.value) filter["responseStatusIdList"] = (_payload76 = payload) === null || _payload76 === void 0 ? void 0 : (_payload76$responseSt = _payload76.responseStatusIdList) === null || _payload76$responseSt === void 0 ? void 0 : _payload76$responseSt.value;else if (Array.isArray((_payload77 = payload) === null || _payload77 === void 0 ? void 0 : _payload77.responseStatusIdList)) filter["responseStatusIdList"] = (_payload78 = payload) === null || _payload78 === void 0 ? void 0 : _payload78.responseStatusIdList;

          // Locked Unlocked
          if (((_payload79 = payload) === null || _payload79 === void 0 ? void 0 : (_payload79$colLockedU = _payload79.colLockedUnlocked) === null || _payload79$colLockedU === void 0 ? void 0 : _payload79$colLockedU.length) === 2) {
            delete payload.colLockedUnlocked;
          } else if (((_payload80 = payload) === null || _payload80 === void 0 ? void 0 : (_payload80$colLockedU = _payload80.colLockedUnlocked) === null || _payload80$colLockedU === void 0 ? void 0 : _payload80$colLockedU.length) === 1) {
            payload.colLockedUnlocked[0] === "locked" && (filter["locked"] = true);
            payload.colLockedUnlocked[0] === "unLocked" && (filter["unlocked"] = true);
          }

          // Tag
          if (((_payload81 = payload) === null || _payload81 === void 0 ? void 0 : (_payload81$tags = _payload81.tags) === null || _payload81$tags === void 0 ? void 0 : _payload81$tags.length) > 0) {
            colTags = "";
            (_payload82 = payload) === null || _payload82 === void 0 ? void 0 : (_payload82$tags = _payload82.tags) === null || _payload82$tags === void 0 ? void 0 : _payload82$tags.forEach(function (item) {
              colTags = colTags ? colTags + "," + item.colTags : item.colTags;
            });
            if (colTags) filter["colTags"] = colTags;
          }
          (_payload83 = payload) === null || _payload83 === void 0 ? true : delete _payload83.responseStatusIdList;
          (_payload84 = payload) === null || _payload84 === void 0 ? true : delete _payload84.colLockedUnlocked;
          delete payload.tags;
          delete payload.colTags;
          payload = _objectSpread(_objectSpread({}, payload), filter);
          _context26.next = 12;
          return (0, _effects.call)(_services.recipientDeleteBulkApi, payload);
        case 12:
          response = _context26.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data26 = response.data) === null || _response$data26 === void 0 ? void 0 : _response$data26.code) === 207)) {
            _context26.next = 18;
            break;
          }
          _context26.next = 16;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 16:
          _context26.next = 20;
          break;
        case 18:
          _context26.next = 20;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 20:
          _context26.next = 26;
          break;
        case 22:
          _context26.prev = 22;
          _context26.t0 = _context26["catch"](0);
          _context26.next = 26;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.DELETE_BULK, _context26.t0));
        case 26:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[0, 22]]);
  })();
}

// Uploader

/**
 * Prefight
 * @param payload
 * @returns api response
 * @description this function used to Prefight.
 */
function recipientPrefight(_ref27) {
  var payload = _ref27.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
    var _response$data27, response;
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.prev = 0;
          _context27.next = 3;
          return (0, _effects.call)(_services.recipientPrefightApi, payload);
        case 3:
          response = _context27.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data27 = response.data) === null || _response$data27 === void 0 ? void 0 : _response$data27.code) === 207)) {
            _context27.next = 9;
            break;
          }
          _context27.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.PREFIGHT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context27.next = 11;
          break;
        case 9:
          _context27.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.PREFIGHT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context27.next = 17;
          break;
        case 13:
          _context27.prev = 13;
          _context27.t0 = _context27["catch"](0);
          _context27.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.PREFIGHT, _context27.t0));
        case 17:
        case "end":
          return _context27.stop();
      }
    }, _callee27, null, [[0, 13]]);
  })();
}

/**
 * Import
 * @param payload
 * @returns api response
 * @description this function used to Import.
 */
function recipientImport(_ref28) {
  var payload = _ref28.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
    var _response$data28, response;
    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.prev = 0;
          _context28.next = 3;
          return (0, _effects.call)(_services.recipientImportApi, payload);
        case 3:
          response = _context28.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data28 = response.data) === null || _response$data28 === void 0 ? void 0 : _response$data28.code) === 201)) {
            _context28.next = 9;
            break;
          }
          _context28.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.IMPORT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context28.next = 11;
          break;
        case 9:
          _context28.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.IMPORT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context28.next = 17;
          break;
        case 13:
          _context28.prev = 13;
          _context28.t0 = _context28["catch"](0);
          _context28.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.IMPORT, _context28.t0));
        case 17:
        case "end":
          return _context28.stop();
      }
    }, _callee28, null, [[0, 13]]);
  })();
}

/**
 * Error Sheet Download
 * @param payload
 * @returns api response
 * @description this function used to Error Sheet Download.
 */
function recipientErrorSheetDownload(_ref29) {
  var payload = _ref29.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
    var _response$data29, response;
    return _regeneratorRuntime().wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          _context29.next = 3;
          return (0, _effects.call)(_services.recipientErrorSheetDownloadApi, payload);
        case 3:
          response = _context29.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data29 = response.data) === null || _response$data29 === void 0 ? void 0 : _response$data29.code) === 200)) {
            _context29.next = 9;
            break;
          }
          _context29.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.ERROR_SHEET_DOWNLOAD, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context29.next = 11;
          break;
        case 9:
          _context29.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.ERROR_SHEET_DOWNLOAD, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context29.next = 17;
          break;
        case 13:
          _context29.prev = 13;
          _context29.t0 = _context29["catch"](0);
          _context29.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.ERROR_SHEET_DOWNLOAD, _context29.t0));
        case 17:
        case "end":
          return _context29.stop();
      }
    }, _callee29, null, [[0, 13]]);
  })();
}

/**
 * Analytics Get Survey Recipient Response
 * @param payload
 * @returns api response
 * @description this function used to Analytics Get Survey Recipient Response.
 */
function recipientGetSurveyRecipientResponse(_ref30) {
  var payload = _ref30.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
    var _response$data30, response;
    return _regeneratorRuntime().wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.prev = 0;
          _context30.next = 3;
          return (0, _effects.call)(_services.recipientAnalyticsGetSurveyRecipientResponseApi, payload);
        case 3:
          response = _context30.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data30 = response.data) === null || _response$data30 === void 0 ? void 0 : _response$data30.code) === 200)) {
            _context30.next = 9;
            break;
          }
          _context30.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.ANALYTICS_GET_SURVEY_RECIPIENT_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context30.next = 11;
          break;
        case 9:
          _context30.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.ANALYTICS_GET_SURVEY_RECIPIENT_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context30.next = 17;
          break;
        case 13:
          _context30.prev = 13;
          _context30.t0 = _context30["catch"](0);
          _context30.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.ANALYTICS_GET_SURVEY_RECIPIENT_RESPONSE, _context30.t0));
        case 17:
        case "end":
          return _context30.stop();
      }
    }, _callee30, null, [[0, 13]]);
  })();
}

/**
 * recipient unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
function recipientUniqueReferenceNo(_ref31) {
  var payload = _ref31.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
    var _response$data31, response;
    return _regeneratorRuntime().wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.prev = 0;
          _context31.next = 3;
          return (0, _effects.call)(_services.recipientUniqueReferenceNoApi, payload);
        case 3:
          response = _context31.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data31 = response.data) === null || _response$data31 === void 0 ? void 0 : _response$data31.code) === 202)) {
            _context31.next = 9;
            break;
          }
          _context31.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.UNIQUE_REFERENCE_NO, response.data.data));
        case 7:
          _context31.next = 11;
          break;
        case 9:
          _context31.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNIQUE_REFERENCE_NO, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context31.next = 17;
          break;
        case 13:
          _context31.prev = 13;
          _context31.t0 = _context31["catch"](0);
          _context31.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNIQUE_REFERENCE_NO, _context31.t0));
        case 17:
        case "end":
          return _context31.stop();
      }
    }, _callee31, null, [[0, 13]]);
  })();
}

/**
 * recipient unique reference no
 * @param payload
 * @returns api response
 * @description this function used to get unique reference no of recipient.
 */
function recipientUniqueMail(_ref32) {
  var payload = _ref32.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
    var _response$data32, response;
    return _regeneratorRuntime().wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          _context32.prev = 0;
          _context32.next = 3;
          return (0, _effects.call)(_services.recipientUniqueMailApi, payload);
        case 3:
          response = _context32.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data32 = response.data) === null || _response$data32 === void 0 ? void 0 : _response$data32.code) === 202)) {
            _context32.next = 9;
            break;
          }
          _context32.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.UNIQUE_MAIL, response.data.data));
        case 7:
          _context32.next = 11;
          break;
        case 9:
          _context32.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNIQUE_MAIL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context32.next = 17;
          break;
        case 13:
          _context32.prev = 13;
          _context32.t0 = _context32["catch"](0);
          _context32.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.UNIQUE_MAIL, _context32.t0));
        case 17:
        case "end":
          return _context32.stop();
      }
    }, _callee32, null, [[0, 13]]);
  })();
}

// link

/**
 * Check Recipient
 * @param payload
 * @returns api response
 * @description this function used to Check Recipient.
 * @param data
 */
function checkRecipient(_ref33) {
  var payload = _ref33.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
    var _response$data33, response;
    return _regeneratorRuntime().wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.prev = 0;
          _context33.next = 3;
          return (0, _effects.call)(_services.checkRecipientApi, payload);
        case 3:
          response = _context33.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data33 = response.data) === null || _response$data33 === void 0 ? void 0 : _response$data33.code) === 200)) {
            _context33.next = 9;
            break;
          }
          _context33.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.CHECK_RECIPIENT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context33.next = 11;
          break;
        case 9:
          _context33.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.CHECK_RECIPIENT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context33.next = 17;
          break;
        case 13:
          _context33.prev = 13;
          _context33.t0 = _context33["catch"](0);
          _context33.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.CHECK_RECIPIENT, _context33.t0));
        case 17:
        case "end":
          return _context33.stop();
      }
    }, _callee33, null, [[0, 13]]);
  })();
}

/**
 * Check Survey
 * @param payload
 * @returns api response
 * @description this function used to Check Survey.
 * @param data
 */
function checkSurvey(_ref34) {
  var payload = _ref34.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
    var _response$data34, response;
    return _regeneratorRuntime().wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          _context34.prev = 0;
          _context34.next = 3;
          return (0, _effects.call)(_services.checkSurveyApi, payload);
        case 3:
          response = _context34.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data34 = response.data) === null || _response$data34 === void 0 ? void 0 : _response$data34.code) === 200)) {
            _context34.next = 9;
            break;
          }
          _context34.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.CHECK_SURVEY, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context34.next = 11;
          break;
        case 9:
          _context34.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.CHECK_SURVEY, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context34.next = 17;
          break;
        case 13:
          _context34.prev = 13;
          _context34.t0 = _context34["catch"](0);
          _context34.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.CHECK_SURVEY, _context34.t0));
        case 17:
        case "end":
          return _context34.stop();
      }
    }, _callee34, null, [[0, 13]]);
  })();
}

/**
 * Link Survey And Recipient Response
 * @param payload
 * @returns api response
 * @description this function used to Link Survey And Recipient Response.
 * @param data
 */
function linkSurveyAndRecipientResponse(_ref35) {
  var payload = _ref35.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
    var _response$data35, response;
    return _regeneratorRuntime().wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.prev = 0;
          _context35.next = 3;
          return (0, _effects.call)(_services.linkSurveyAndRecipientResponseApi, payload);
        case 3:
          response = _context35.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data35 = response.data) === null || _response$data35 === void 0 ? void 0 : _response$data35.code) === 201)) {
            _context35.next = 9;
            break;
          }
          _context35.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context35.next = 11;
          break;
        case 9:
          _context35.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context35.next = 17;
          break;
        case 13:
          _context35.prev = 13;
          _context35.t0 = _context35["catch"](0);
          _context35.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE, _context35.t0));
        case 17:
        case "end":
          return _context35.stop();
      }
    }, _callee35, null, [[0, 13]]);
  })();
}

/**
 * Link Single Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete.
 * @param data
 */
function linkSingleSoftDelete(_ref36) {
  var payload = _ref36.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
    var _response$data36, response;
    return _regeneratorRuntime().wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          _context36.prev = 0;
          _context36.next = 3;
          return (0, _effects.call)(_services.linkSingleSoftDeleteApi, payload);
        case 3:
          response = _context36.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data36 = response.data) === null || _response$data36 === void 0 ? void 0 : _response$data36.code) === 200)) {
            _context36.next = 9;
            break;
          }
          _context36.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context36.next = 11;
          break;
        case 9:
          _context36.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context36.next = 17;
          break;
        case 13:
          _context36.prev = 13;
          _context36.t0 = _context36["catch"](0);
          _context36.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE, _context36.t0));
        case 17:
        case "end":
          return _context36.stop();
      }
    }, _callee36, null, [[0, 13]]);
  })();
}

/**
 * Link Single Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete Bulk.
 * @param data
 */
function linkSingleSoftDeleteBulk(_ref37) {
  var payload = _ref37.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
    var _response$data37, response;
    return _regeneratorRuntime().wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          _context37.prev = 0;
          _context37.next = 3;
          return (0, _effects.call)(_services.linkSingleSoftDeleteBulkApi, payload);
        case 3:
          response = _context37.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data37 = response.data) === null || _response$data37 === void 0 ? void 0 : _response$data37.code) === 207)) {
            _context37.next = 9;
            break;
          }
          _context37.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context37.next = 11;
          break;
        case 9:
          _context37.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context37.next = 17;
          break;
        case 13:
          _context37.prev = 13;
          _context37.t0 = _context37["catch"](0);
          _context37.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK, _context37.t0));
        case 17:
        case "end":
          return _context37.stop();
      }
    }, _callee37, null, [[0, 13]]);
  })();
}

/**
 * Link Single Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Link Single Soft Delete Bulk.
 * @param data
 */
function recipientUnpageStatusList(_ref38) {
  var payload = _ref38.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
    var _response$data38, response;
    return _regeneratorRuntime().wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          _context38.prev = 0;
          _context38.next = 3;
          return (0, _effects.call)(_services.recipientUnpageStatusListApi, payload);
        case 3:
          response = _context38.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data38 = response.data) === null || _response$data38 === void 0 ? void 0 : _response$data38.code) === 200)) {
            _context38.next = 9;
            break;
          }
          _context38.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.LIST_UNPAGED, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context38.next = 11;
          break;
        case 9:
          _context38.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST_UNPAGED, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context38.next = 17;
          break;
        case 13:
          _context38.prev = 13;
          _context38.t0 = _context38["catch"](0);
          _context38.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.LIST_UNPAGED, _context38.t0));
        case 17:
        case "end":
          return _context38.stop();
      }
    }, _callee38, null, [[0, 13]]);
  })();
}

/**
 * survey configuration fetch
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration.
 */
function surveyConfigurationFetchResponse(_ref39) {
  var payload = _ref39.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
    var _response$data39, response;
    return _regeneratorRuntime().wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          _context39.prev = 0;
          _context39.next = 3;
          return (0, _effects.call)(_services.surveyConfigurationFetchResponseApi, payload);
        case 3:
          response = _context39.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data39 = response.data) === null || _response$data39 === void 0 ? void 0 : _response$data39.code) === 200)) {
            _context39.next = 9;
            break;
          }
          _context39.next = 7;
          return (0, _effects.put)((0, _recipient.recipientSuccess)(_recipient2.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE, response.data));
        case 7:
          _context39.next = 11;
          break;
        case 9:
          _context39.next = 11;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE, response.data));
        case 11:
          _context39.next = 17;
          break;
        case 13:
          _context39.prev = 13;
          _context39.t0 = _context39["catch"](0);
          _context39.next = 17;
          return (0, _effects.put)((0, _recipient.recipientError)(_recipient2.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE, _context39.t0));
        case 17:
        case "end":
          return _context39.stop();
      }
    }, _callee39, null, [[0, 13]]);
  })();
}
var watchRecipient = function watchRecipient() {
  return /*#__PURE__*/_regeneratorRuntime().mark(function watch() {
    return _regeneratorRuntime().wrap(function watch$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          _context40.next = 2;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.UNIQUE_REFERENCE_NO, recipientUniqueReferenceNo);
        case 2:
          _context40.next = 4;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.UNIQUE_MAIL, recipientUniqueMail);
        case 4:
          _context40.next = 6;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LIST, recipientList);
        case 6:
          _context40.next = 8;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LIST_LINK, recipientListLink);
        case 8:
          _context40.next = 10;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LIST_SEARCH, recipientListSearch);
        case 10:
          _context40.next = 12;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.CREATE, recipientCreate);
        case 12:
          _context40.next = 14;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.UPDATE, recipientUpdate);
        case 14:
          _context40.next = 16;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LINKED_FUND, recipientLinkedFund);
        case 16:
          _context40.next = 18;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SAVE_LINKED_FUND, recipientSaveLinkedFund);
        case 18:
          _context40.next = 20;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LOCK, recipientLock);
        case 20:
          _context40.next = 22;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LOCK_BULK, recipientLockBulk);
        case 22:
          _context40.next = 24;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.UNLOCK, recipientUnlock);
        case 24:
          _context40.next = 26;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.UNLOCK_BULK, recipientUnlockBulk);
        case 26:
          _context40.next = 28;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SOFT_DELETE, recipientSoftDelete);
        case 28:
          _context40.next = 30;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SOFT_DELETE_BULK, recipientSoftDeleteBulk);
        case 30:
          _context40.next = 32;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SUBMIT, recipientSubmit);
        case 32:
          _context40.next = 34;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SUBMIT_BULK, recipientSubmitBulk);
        case 34:
          _context40.next = 36;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.APPROVE, recipientApprove);
        case 36:
          _context40.next = 38;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.APPROVE_BULK, recipientApproveBulk);
        case 38:
          _context40.next = 40;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.COPY_URL, recipientCopyUrl);
        case 40:
          _context40.next = 42;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.DOWNLOAD, recipientDownload);
        case 42:
          _context40.next = 44;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.DOWNLOAD_ALL, recipientDownloadAll);
        case 44:
          _context40.next = 46;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.DOWNLOAD_SURVEY_RESPONSE, recipientDownloadSurveyResponse);
        case 46:
          _context40.next = 48;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SOFT_DELETE_LIST, recipientSoftDeleteList);
        case 48:
          _context40.next = 50;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.RESTORE, recipientRestore);
        case 50:
          _context40.next = 52;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.RESTORE_BULK, recipientRestoreBulk);
        case 52:
          _context40.next = 54;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.DELETE, recipientDelete);
        case 54:
          _context40.next = 56;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.DELETE_BULK, recipientDeleteBulk);
        case 56:
          _context40.next = 58;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.PREFIGHT, recipientPrefight);
        case 58:
          _context40.next = 60;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.IMPORT, recipientImport);
        case 60:
          _context40.next = 62;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.ERROR_SHEET_DOWNLOAD, recipientErrorSheetDownload);
        case 62:
          _context40.next = 64;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.GET_SURVEY_RECIPENT_RESPONSE, recipientGetSurveyRecipientResponse);
        case 64:
          _context40.next = 66;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.CHECK_RECIPIENT, checkRecipient);
        case 66:
          _context40.next = 68;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.CHECK_SURVEY, checkSurvey);
        case 68:
          _context40.next = 70;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LINK_SURVEY_AND_RECIPIENT_RESPONSE, linkSurveyAndRecipientResponse);
        case 70:
          _context40.next = 72;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE, linkSingleSoftDelete);
        case 72:
          _context40.next = 74;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LINK_SINGLE_SOFT_DELETE_BULK, linkSingleSoftDeleteBulk);
        case 74:
          _context40.next = 76;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.LIST_UNPAGED, recipientUnpageStatusList);
        case 76:
          _context40.next = 78;
          return (0, _effects.takeLatest)(_recipient2.actionTypes.SURVEY_CONFIGURATION_FETCH_RESPONSE, surveyConfigurationFetchResponse);
        case 78:
        case "end":
          return _context40.stop();
      }
    }, watch);
  });
};
function recipientSaga() {
  return _regeneratorRuntime().wrap(function recipientSaga$(_context41) {
    while (1) switch (_context41.prev = _context41.next) {
      case 0:
        _context41.next = 2;
        return (0, _effects.all)([(0, _effects.fork)(watchRecipient())]);
      case 2:
      case "end":
        return _context41.stop();
    }
  }, _marked);
}